import React, { useState, useEffect } from 'react';
import {
  SIDEBAR_MODES,
  SIDEBAR_MODE_LABELS,
  getAccountSidebarMode,
  setStoredSidebarMode,
  applySidebarMode,
  isValidSidebarMode,
} from '../../utils/sidebarMode';
import { saveUiPreferencePatch, UI_PREFERENCES_EVENT } from '../../utils/uiPreferences';
import './ThemePickers.css';

/**
 * Default navigation density — Preferences → Appearance.
 * Persists as ui_preferences.sidebar_mode (account + local cache).
 */
export default function SidebarModePicker({ layout = 'page' }) {
  const mode = layout === 'page' ? 'page' : 'compact';
  const [sidebarMode, setSidebarMode] = useState(() => getAccountSidebarMode());

  useEffect(() => {
    const sync = () => setSidebarMode(getAccountSidebarMode());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener(UI_PREFERENCES_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(UI_PREFERENCES_EVENT, sync);
    };
  }, []);

  const select = (id) => {
    if (!isValidSidebarMode(id)) return;
    setSidebarMode(id);
    setStoredSidebarMode(id);
    applySidebarMode(id);
    // Marks sidebar_mode_explicit on the server via upsert
    saveUiPreferencePatch({ sidebar_mode: id });
  };

  return (
    <div className={`shell-theme-picker shell-theme-picker--${mode}`}>
      <div className="shell-theme-picker-label">Default navigation</div>
      <div className="sidebar-mode-picker-options" role="listbox" aria-label="Default navigation">
        {SIDEBAR_MODES.map((id) => (
          <button
            key={id}
            type="button"
            role="option"
            aria-selected={sidebarMode === id}
            className={`sidebar-mode-option${sidebarMode === id ? ' active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              select(id);
            }}
          >
            {SIDEBAR_MODE_LABELS[id]}
          </button>
        ))}
      </div>
      <div className="shell-theme-picker-current">
        {SIDEBAR_MODE_LABELS[sidebarMode]} · saved default · ☰ only changes this session
      </div>
    </div>
  );
}
